//import { createBrowserHistory } from 'history';
import { createHashHistory } from 'history';

//export const history = createBrowserHistory();
export const history = createHashHistory();
